import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, List, ScanLine, Search, Settings, Zap, Stethoscope, Baby } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/lib/auth";

const TABS_OWNER = [
  { key: "dashboard", label: "Resumen",    icon: LayoutDashboard, to: "/" },
  { key: "actions",   label: "Acciones",   icon: Zap,             to: "/acciones" },
  { key: "animals",   label: "Animales",   icon: List,            to: "/animales" },
  { key: "inventory", label: "Inventario", icon: ScanLine,        to: "/inventario" },
  { key: "search",    label: "Buscar",     icon: Search,          to: "/buscar" },
  { key: "settings",  label: "Ajustes",    icon: Settings,        to: "/ajustes" },
];
// Fix P (2026-10-06): el encargado ya no tiene Acciones; en su lugar, Resumen.
const TABS_HANDLER = [
  { key: "dashboard", label: "Resumen",    icon: LayoutDashboard, to: "/" },
  { key: "animals",   label: "Animales",   icon: List,     to: "/animales" },
  { key: "inventory", label: "Inventario", icon: ScanLine, to: "/inventario" },
  { key: "search",    label: "Buscar",     icon: Search,   to: "/buscar" },
  { key: "settings",  label: "Ajustes",    icon: Settings, to: "/ajustes" },
];
// El veterinario tiene acceso acotado: solo palpación, animales de su finca,
// nacimientos previstos (su insumo de trabajo) y ajustes básicos.
const TABS_VET = [
  { key: "palpation", label: "Palpación", icon: Stethoscope, to: "/acciones/11" },
  { key: "animals",   label: "Animales",  icon: List,        to: "/animales" },
  { key: "births",    label: "Partos",    icon: Baby,        to: "/nacimientos-previstos" },
  { key: "search",    label: "Buscar",    icon: Search,      to: "/buscar" },
  { key: "settings",  label: "Ajustes",   icon: Settings,    to: "/ajustes" },
];

export function BottomNav() {
  const { user } = useAuth();
  const tabs = user?.role === "vet" ? TABS_VET : user?.role === "handler" ? TABS_HANDLER : TABS_OWNER;
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 inset-x-0 z-30 bg-background/95 backdrop-blur-md border-t border-border pb-safe"
    >
      <div
        className="max-w-6xl mx-auto px-2 grid"
        style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0,1fr))` }}
      >
        {tabs.map((t) => (
          <NavLink
            key={t.key}
            to={t.to}
            end={t.to === "/"}
            data-testid={`bottom-nav-${t.key}`}
            className={({ isActive }) =>
              cn(
                "relative flex flex-col items-center justify-center py-2.5 gap-0.5 text-[10.5px] font-medium transition-colors duration-150 min-h-[64px]",
                isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
              )
            }
          >
            {({ isActive }) => (
              <>
                <t.icon size={20} strokeWidth={isActive ? 2.2 : 1.8} />
                <span className="tracking-tight">{t.label}</span>
                {isActive && (
                  <span
                    aria-hidden
                    className="absolute bottom-1 h-[2px] w-5 rounded-full bg-primary"
                  />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
